<ag-shr-modal-window
  #guestModalComponentRef
  *var="
    (Entity.conferenceAttendeeDetails | hasPermission: activity | async) &&
    guestFormDataSig()?.[GuestKeys.guestStatus] !== GuestStatus.canceled as canWrite
  "
  [title]="title"
  [width]="800"
  [height]="1000"
  [inProgress]="inProgress$ | async"
  [onCloseModal]="handleClosePopup"
  [showSaveButton]="canWrite"
  (onSaveClick)="handleSaveApproveDenyReason($event)"
  [customClass]="'attendee-guest-modal__popup-wrapper'"
>
  @if (guestModalComponentRef?.popupComponent?.visible ?? false) {
    @if (associationsStateSig()?.inProgress) {
      <dx-load-panel
        [container]="'.attendee-guest-modal__popup-wrapper .dx-popup-normal'"
        shadingColor="rgba(0,0,0,0.4)"
        [visible]="true"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [hideOnOutsideClick]="false"
      >
      </dx-load-panel>
    } @else {
      <ag-shr-select-association
        [isReadonly]="!canWrite"
        [newAssociationTitle]="'Add another'"
        [association]="guestFormDataSig()"
        [associationKeyExpr]="getAssociationKey"
        [associations]="registrantAssociationsSig()"
        [propertiesToAssign]="propertiesToAssign"
        [onAssociationChanged]="onAssociationChanged"
      ></ag-shr-select-association>

      <dx-form
        *ngIf="guestModalComponentRef?.popupComponent?.visible ?? false"
        #guestFormRef
        [formData]="guestFormDataSig()"
        labelMode="floating"
        class="guest-form"
        [screenByWidth]="formSize$ | async | formScreenByWidth"
        [readOnly]="!canWrite"
        (onInitialized)="onFormInitialized($event)"
      >
        <dxi-item itemType="group" caption="Guest Type" [colCountByScreen]="colCountByScreen">
          <dxi-item
            [colSpan]="6"
            [dataField]="[GuestKeys.complimentaryConfiguration, GuestEvents.main] | path"
            [editorType]="'dxSelectBox'"
            [label]="{ text: 'Conference Complimentary?' }"
            [editorOptions]="{
              items: guestTypesLookup,
              displayExpr: LookupKeys.description,
              valueExpr: LookupKeys.value,
              readOnly: !canWrite,
            }"
          ></dxi-item>

          @if (isAcceptedChairmanExtensionSig()) {
            <dxi-item
              [colSpan]="6"
              [dataField]="[GuestKeys.complimentaryConfiguration, GuestEvents.chairmanExtension] | path"
              [editorType]="'dxSelectBox'"
              [label]="{ text: 'Chairman Ext. Complimentary?' }"
              [editorOptions]="{
                items: guestTypesLookup,
                displayExpr: LookupKeys.description,
                valueExpr: LookupKeys.value,
                readOnly: !canWrite,
              }"
            ></dxi-item>
          }
        </dxi-item>

        <dxi-item itemType="group" caption="Guest Events" [colCountByScreen]="colCountByScreen">
          <dxi-item [colSpan]="6">
            <div *dxTemplate>
              <dx-tag-box
                [label]="'Events'"
                [labelMode]="'floating'"
                [dataSource]="guestEventsLookup"
                [valueExpr]="LookupKeys.value"
                [displayExpr]="LookupKeys.description"
                [value]="guestFormDataSig()?.[GuestKeys.guestEvents]"
                [showSelectionControls]="true"
                applyValueMode="useButtons"
                [searchEnabled]="true"
                (valueChange)="guestFormDataSig() && (guestFormDataSig()[GuestKeys.guestEvents] = $event)"
                class="guest-form__tag-box"
                [readOnly]="!canWrite"
              >
                <dx-validator [validationGroup]="guestEventsValidationGroup">
                  <dxi-validation-rule [type]="'required'"></dxi-validation-rule>
                </dx-validator>
              </dx-tag-box>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Preferred Name" [colCountByScreen]="colCountByScreen">
          <dxi-item
            [colSpan]="2"
            [dataField]="AssociationKeys.prefix"
            [editorType]="'dxSelectBox'"
            [label]="{ text: 'Prefix' }"
            [editorOptions]="{
              items: prefixesLookup$ | async,
              displayExpr: LookupKeys.description,
              valueExpr: BaseModelKeys.dbId,
              showClearButton: true,
              allowClearing: true,
              readOnly: !canWrite,
            }"
          >
          </dxi-item>

          <dxi-item [colSpan]="4" [dataField]="AssociationKeys.firstName" [label]="{ text: 'First Name' }"></dxi-item>

          <dxi-item [colSpan]="4" [dataField]="AssociationKeys.lastName" [label]="{ text: 'Last Name' }"></dxi-item>

          <dxi-item
            [colSpan]="2"
            [dataField]="AssociationKeys.suffix"
            [label]="{ text: 'Suffix' }"
            [editorType]="'dxSelectBox'"
            [editorOptions]="{
              items: suffixesLookup$ | async,
              displayExpr: LookupKeys.description,
              valueExpr: BaseModelKeys.dbId,
              showClearButton: true,
              allowClearing: true,
            }"
          ></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Guest badge name (i.e. John Smith):" [colCountByScreen]="colCountByScreen">
          <dxi-item [colSpan]="3" [dataField]="GuestKeys.badgeName" [label]="{ text: 'Badge Name' }"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Gender:" [colCountByScreen]="colCountByScreen">
          <dxi-item
            [colSpan]="3"
            [dataField]="AssociationKeys.gender"
            [label]="{ text: 'Gender' }"
            [editorType]="'dxSelectBox'"
            [editorOptions]="{
              items: gendersLookup$ | async,
              displayExpr: LookupKeys.description,
              valueExpr: BaseModelKeys.dbId,
              showClearButton: true,
              allowClearing: true,
            }"
          ></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Date of Birth:" [colCountByScreen]="colCountByScreen">
          <dxi-item
            [colSpan]="3"
            [dataField]="AssociationKeys.dob"
            editorType="dxDateBox"
            [label]="{ text: 'Day of Birth' }"
            [editorOptions]="dateEditorOptions"
          >
            <dxi-validation-rule
              type="async"
              [message]="'Two adults and two children, or three adults and one child'"
              [validationCallback]="hotelRulesValidationCallback"
            >
            </dxi-validation-rule>
          </dxi-item>
        </dxi-item>

        <dxi-item [itemType]="'group'" caption="Relationship to Attendee:" [colCountByScreen]="colCountByScreen">
          <dxi-item [colSpan]="3" [dataField]="AssociationKeys.associationType" [label]="{ showColon: true }">
            <div *dxTemplate>
              <ag-shr-relationship-type-select-box
                [readOnly]="!canWrite"
                [value]="guestFormDataSig()?.[AssociationKeys.associationType]"
                (valueChange)="guestFormDataSig() && (guestFormDataSig()[AssociationKeys.associationType] = $event)"
                [validationGroup]="validationGroup"
              ></ag-shr-relationship-type-select-box>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item
          [itemType]="'group'"
          caption="Shirt Size:"
          [colCountByScreen]="colCountByScreen"
          [visible]="
            ConferenceGuestsStepsConfigurationSectionName.shirtSizeSection
              | conferenceGuestSectionVisible: (conferenceGuestExcludedSections$ | async)
          "
        >
          <dxi-item [colSpan]="12">
            <div *dxTemplate>
              <ag-shr-t-shirt-sizes-form
                [formData]="guestFormDataSig()?.[AssociationKeys.tShirtSizes]"
                [tShirtBlockVisible]="
                  [RegistrantKeys.isGuestsAttended, RegistrantKeys.tShirtSizes, TShirtSizesKeys.unisextShirtSize]
                    | path
                    | conferenceGuestInfoFieldVisible
                    | async
                "
                [shirtBlockVisible]="
                  [RegistrantKeys.isGuestsAttended, RegistrantKeys.tShirtSizes, TShirtSizesKeys.genderTShirtSize]
                    | path
                    | conferenceGuestInfoFieldVisible
                    | async
                "
                [validationGroup]="tShirtSizesValidationGroup"
                [tShirtNote]="'Note: T-shirts are unisex.'"
                layout="horizontal"
                [readOnly]="!canWrite"
              ></ag-shr-t-shirt-sizes-form>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item
          [itemType]="'group'"
          caption="Does your guest have a dietary or personal consideration?"
          [colCountByScreen]="colCountByScreen"
          [visible]="
            ConferenceGuestsStepsConfigurationSectionName.dietaryConsiderationsSection
              | conferenceGuestSectionVisible: (conferenceGuestExcludedSections$ | async)
          "
        >
          <dxi-item [colSpan]="12">
            <div *dxTemplate>
              <ag-shr-dietary-considerations-form
                [isReadOnly]="!canWrite"
                [label]="'Does guest have a dietary or personal consideration?'"
                [validationGroup]="dietaryConsiderationValidationGroup"
                [dietaryConsiderations]="guestFormDataSig()?.[AssociationKeys.dietaryConsideration]"
              ></ag-shr-dietary-considerations-form>
            </div>
          </dxi-item>
        </dxi-item>
      </dx-form>
    }
  }
</ag-shr-modal-window>
